module.exports = __webpack_public_path__ + "static/img/40012 (4).02cca56.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40012 (4).webp
// module id = e3Ke
// module chunks = 14